module.exports = __webpack_public_path__ + "img/82.c351d757.png";